var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlindsBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 332,
    viewBox: "0 0 329 332",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F8FB",
    d: "M0 .5h329v331H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43C0FF",
    d: "M22 155h284v9H22zM22 140h284v9H22zM22 124h284v9H22zM22 109h284v9H22zM22 93h284v9H22zM22 78h284v9H22zM22 63h284v9H22zM22 47h284v9H22zM22 32h284v9H22zM22 16h284v9H22zM22 1h284v9H22zM22 170h284v9H22zM22 185h284v9H22zM22 200h284v9H22zM22 215h284v9H22zM22 231h284v9H22zM22 246h284v9H22zM22 261h284v9H22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32B8FC",
    d: "M22 276h284v9H22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#349EFD",
    d: "M22 291h284v9H22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2798FD",
    d: "M22 307h284v9H22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#208EF0",
    d: "M22 322h284v9H22z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlindsBackground);
export default __webpack_public_path__ + "static/media/blindsBackground.247916765048571ff772a6b4a6cb4eb9.svg";
export { ForwardRef as ReactComponent };